<template>
  <component
    :is="iconName"
    :class="`icon-square ${iconName}`"
    :color="color"
  />
</template>

<script>
const _camelCase = require('lodash.camelcase');
const _upperFirst = require('lodash.upperfirst');

const IconArrowRightLong = () => import('./arrow-right-long.vue');
const IconArrowRight = () => import('./arrow-right.vue');
const IconBullhorn = () => import('./bullhorn.vue');
const IconCalendar = () => import('./calendar.vue');
const IconCaret = () => import('./caret.vue');
const IconCartOrder = () => import('./cart-order.vue');
const IconCart = () => import('./cart.vue');
const IconChat = () => import('./chat.vue');
const IconChevronDown = () => import('./chevron-down.vue');
const IconChevronUp = () => import('./chevron-up.vue');
const IconClock = () => import('./clock.vue');
const IconCloseCircle = () => import('./close-circle.vue');
const IconCloseThick = () => import('./close-thick.vue');
const IconClose = () => import('./close.vue');
const IconDotRound = () => import('./dot-round.vue');
const IconEdit = () => import('./edit.vue');
const IconExclamation = () => import('./exclamation.vue');
const IconExclamationCircle = () => import('./exclamation-circle.vue');
const IconHeadphone = () => import('./headphone.vue');
const IconInfoCircle = () => import('./info-circle.vue');
const IconInvalid = () => import('./exclamation.vue');
const IconJoystick = () => import('./joystick.vue');
const IconLoading = () => import('./loading-dots.vue');
const IconPaypal = () => import('./paypal.vue');
const IconPlus = () => import('./plus.vue');
const IconPlusCircle = () => import('./plus-circle.vue');
const IconProfileSlim = () => import('./profile-slim.vue');
const IconProfileCircle = () => import('./profile-circle.vue');
const IconProfile = () => import('./profile.vue');
const IconQbuddy = () => import('./qbuddy.vue');
const IconServiceGameplayReview = () => import('./service-gameplay-review.vue');
const IconServiceTeammateCoach = () => import('./service-teammate-coach.vue');
const IconServiceVideoCourse = () => import('./service-video-course.vue');
const IconServiceVodReview = () => import('./service-vod-review.vue');
const IconServiceVoiceCoach = () => import('./service-voice-coach.vue');
const IconServiceLobbySession = () => import('./service-lobby-session');
const IconStar = () => import('./star.vue');
const IconTickCircle = () => import('./tick-circle.vue');
const IconTimer = () => import('./timer.vue');
const IconTrash = () => import('./trash.vue');
const IconVideoPlay = () => import('./video-play.vue');
const IconGame = () => import('./game.vue');
const IconDiscord = () => import('./discord.vue');
const IconFourSquares = () => import('./four-squares');
const IconBlackClose = () => import('./black-close');
const IconGameCircle = () => import('./game-circle');
const IconAvgl = () => import('./avgl');
const IconHome = () => import('./home');
const IconEventStar = () => import('./event-star');
const IconForm = () => import('./form');
const IconPeople = () => import('./people');
const IconWallet = () => import('./wallet');
const IconSetting = () => import('./setting');
const IconBoom = () => import('./boom');
const IconMyProfile = () => import('./my-profile');
const IconConnections = () => import('./connections');
const IconSignOut = () => import('./sign-out');
const IconMagnifier = () => import('./magnifier');
const IconEventHighlights = () => import('./event-highlights');
const IconClipPlay = () => import('./clip-play');
const IconEventGame = () => import('./event-game');
const IconEventCalendar = () => import('./event-calendar');
const IconEventClock = () => import('./event-clock');
const IconEventDetail = () => import('./event-detail');
const IconEventMobileFormat = () => import('./event-mobile-format');
const IconEventMobileRule = () => import('./event-mobile-rule');
const IconClipTime = () => import('./clip-time');
const IconQuestSuccess = () => import('./quest-success');
const IconQuestFail = () => import('./quest-fail');
const IconQuestPending = () => import('./quest-pending');
const IconTick = () => import('./tick');
const IconFail = () => import('./fail');
const IconChat2 = () => import('./chat2');
const IconVideo = () => import('./video');
const IconExpand = () => import('./expand-icon');
const IconTeam = () => import('./team');
const IconRank = () => import('./rank');
const IconCalendar2 = () => import('./calendar2');
const IconClock2 = () => import('./clock2');
const IconFile = () => import('./file');
const IconVesus = () => import('./vesus');
const IconYoutube = () => import('./youtube');
const IconTwitch = () => import('./twitch');
const IconDiscord2 = () => import('./discord2');
const IconTwitter = () => import('./twitter');
const IconMailBox = () => import('./mail-box');
const IconSmallEdit = () => import('./small-edit');
const IconAdd = () => import('./add');
const IconSub = () => import('./sub');
const IconExportArrow = () => import('./export-arrow');
const IconArrowDown = () => import('./arrow-down');
const IconArrowUp = () => import('./arrow-up');
const IconGroupUser = () => import('./group-user');
const IconArrowHubDropTheme = () => import('./arrow-hub-drop-theme.vue');
const IconWinText = () => import('./win-text.vue');

export default {
  components: {
    IconInvalid,
    IconArrowRightLong,
    IconArrowRight,
    IconBullhorn,
    IconCalendar,
    IconCaret,
    IconCartOrder,
    IconCart,
    IconChat,
    IconChevronDown,
    IconChevronUp,
    IconClock,
    IconCloseCircle,
    IconCloseThick,
    IconClose,
    IconDotRound,
    IconEdit,
    IconExclamation,
    IconExclamationCircle,
    IconHeadphone,
    IconInfoCircle,
    IconJoystick,
    IconLoading,
    IconPlus,
    IconPaypal,
    IconPlusCircle,
    IconProfileCircle,
    IconProfileSlim,
    IconProfile,
    IconQbuddy,
    IconServiceGameplayReview,
    IconServiceLobbySession,
    IconServiceQueueBuddy: IconQbuddy,
    IconServiceTeammateCoach,
    IconServiceVideoCourse,
    IconServiceVodReview,
    IconServiceVoiceCoach,
    IconStar,
    IconTickCircle,
    IconTimer,
    IconTrash,
    IconVideoPlay,
    IconGame,
    IconDiscord,
    IconFourSquares,
    IconBlackClose,
    IconGameCircle,
    IconAvgl,
    IconHome,
    IconEventStar,
    IconForm,
    IconPeople,
    IconWallet,
    IconSetting,
    IconBoom,
    IconMyProfile,
    IconConnections,
    IconSignOut,
    IconMagnifier,
    IconEventHighlights,
    IconClipPlay,
    IconEventGame,
    IconEventCalendar,
    IconEventClock,
    IconEventDetail,
    IconEventMobileFormat,
    IconEventMobileRule,
    IconClipTime,
    IconQuestSuccess,
    IconQuestFail,
    IconQuestPending,
    IconTick,
    IconFail,
    IconChat2,
    IconVideo,
    IconExpand,
    IconTeam,
    IconRank,
    IconCalendar2,
    IconClock2,
    IconFile,
    IconVesus,
    IconYoutube,
    IconTwitch,
    IconDiscord2,
    IconTwitter,
    IconMailBox,
    IconSmallEdit,
    IconAdd,
    IconSub,
    IconExportArrow,
    IconArrowDown,
    IconArrowUp,
    IconGroupUser,
    IconArrowHubDropTheme,
    IconWinText,
  },
  props: {
    name: {
      type: String,
      default() {
        return '';
      },
    },
    color: {
      type: String,
      default() {
        return undefined;
      },
    },
  },
  computed: {
    iconName() {
      const iconName = `icon-${this.name}`.replace(/\s/g, '-');
      const pascalCased = _upperFirst(_camelCase(iconName));
      const isIconExist = Object.keys(this.$options.components).includes(pascalCased);

      if (isIconExist) {
        return iconName;
      } else {
        return 'icon-invalid';
      }
    },
  },
};
</script>
